import { SourceToOpenSubmitLayerUrlParameter, ReviewSource } from '../types';

export const mapUrlParameterToReviewSource = (urlParameter: SourceToOpenSubmitLayerUrlParameter): ReviewSource => {
    if (urlParameter === 'myAccount') return 'myaccount';
    return urlParameter;
};
